export var CMG_ACCOUNT_TYPE = 'CMG';
export var CDA_ACCOUNT_TYPE = 'CDA';
export var SAVINGS_ACCOUNT_TYPES = ['SDA', 'MMA'];
//# sourceMappingURL=ally-bank.js.map